import createIcon from '../../createIcon';

/**
 * @component @name Rotate
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNS41QzYuNDggNS41IDIgNy43NCAyIDEwLjVDMiAxMi43NCA0Ljk0IDE0LjYzIDkgMTUuMjdWMTguNUwxMyAxNC41TDkgMTAuNVYxMy4yM0M1Ljg1IDEyLjY3IDQgMTEuMzMgNCAxMC41QzQgOS40NCA3LjA0IDcuNSAxMiA3LjVDMTYuOTYgNy41IDIwIDkuNDQgMjAgMTAuNUMyMCAxMS4yMyAxOC41NCAxMi4zOSAxNiAxMy4wM1YxNS4wOEMxOS41MyAxNC4zMSAyMiAxMi41NSAyMiAxMC41QzIyIDcuNzQgMTcuNTIgNS41IDEyIDUuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Rotate = createIcon('Rotate', [
  [
    'path',
    {
      d: 'M12 5.5C6.48 5.5 2 7.74 2 10.5C2 12.74 4.94 14.63 9 15.27V18.5L13 14.5L9 10.5V13.23C5.85 12.67 4 11.33 4 10.5C4 9.44 7.04 7.5 12 7.5C16.96 7.5 20 9.44 20 10.5C20 11.23 18.54 12.39 16 13.03V15.08C19.53 14.31 22 12.55 22 10.5C22 7.74 17.52 5.5 12 5.5Z',
      key: '1tb59l',
    },
  ],
]);

export default Rotate;
